import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { PRICE_USD } from '../data/checkout';
import { totalValue } from '../data/offer';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 900);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-131" data-mp="3ubu5fxcefb6y">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-ink/95 px-4 py-3 backdrop-blur" data-id="element-132" data-mp="3glgt7ish5abt">
          <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-between gap-3" data-id="element-133" data-mp="gyqwrv3an9yd">
            <div className="hidden sm:block" data-id="element-134" data-mp="76xe2cos0w69">
              <p className="font-display text-xl font-bold uppercase leading-none tracking-tightest text-white" data-id="element-135" data-mp="73j9qywjycw6">
                The HYROX Coach Blueprint
              </p>
              <p className="mt-1 font-sans text-xs text-muted" data-id="element-136" data-mp="gx9zs88buvdz">
                ${totalValue} value • Today ${PRICE_USD} • 7-day guarantee
              </p>
            </div>
            <CtaButton size="md" label={`Get the Blueprint — ${PRICE_USD}`} className="w-full sm:w-auto" data-id="element-137" data-mp="pvc52zz3ga72" />
          </div>
        </motion.div>}
    </AnimatePresence>;
}